import React, { useState } from 'react'
import { Currency } from '../../model'
import { TokenSelectButton } from './TokenSelectButton'
import { CurrencyButton } from './CurrencyButton'
import { CurrencySelectModal } from './CurrencySelectModal'

interface Props {
  currency?: Currency
  other?: Currency
  onChange: (value: Currency) => void
}

export function CurrencySelect({ currency, other, onChange }: Props) {
  const [visible, setVisible] = useState<boolean>(false)

  function onSelect(value: Currency) {
    setVisible(false)
    onChange(value)
  }

  const disabled = [currency, other].filter((x): x is Currency => x !== undefined)

  return (
    <>
      {visible && <CurrencySelectModal disabled={disabled} onChange={onSelect} onClose={() => setVisible(false)} />}
      {currency && <CurrencyButton currency={currency} onClick={() => setVisible(true)} />}
      {!currency && <TokenSelectButton onClick={() => setVisible(true)} />}
    </>
  )
}
